import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { environment } from '@env/environment';

const logger = new Logger('@template:footer.component.ts');

@Component({
  selector: 'app-footer',
  templateUrl: './footer.template.html',
  styleUrls: ['./footer.template.scss'],
})
export class FooterComponent implements OnInit, OnDestroy, AfterViewInit {
  links = [
    {
      name: 'Information',
      items: [
//        {
//          id: 'terms-and-conditions',
//          name: 'Terms & Conditions',
//          routerLink: '/legal/terms-and-conditions',
//        },
        {
          id: 'verification',
          name: 'Verification',
          href: 'https://etherscan.io/address/0xb22d1f1006aa02ee755e794d9c93dbec4b0bc8ae',
        },
        {
          id: 'privacy-policy',
          name: 'Privacy policy',
          routerLink: '/legal/privacy-policy',
        },
        {
          id: 'bonus-terms',
          name: 'Bonus terms',
          routerLink: '/legal/bonus-terms',
        },
      ],
    },
    {
      name: 'Company',
      items: [
        {
          id: 'about',
          name: 'About',
          href: 'https://edgelessgroup.io',
        },
        {
          id: 'press',
          name: 'Press',
          href: 'https://blog.edgelessgroup.io',
        },
        {
          id: 'careers',
          name: 'Careers',
          href: 'https://blog.edgelessgroup.io/careers',
        },
      ],
    },
    {
      name: 'Learn & Support',
      items: [
        {
          id: 'edgelessstatus',
          name: 'Edgeless status',
          href: 'https://status.edgeless.io',
        },
        // {
        //   name: 'FAQ',
        //   routerLink: '/faq',
        // },
        {
          id: 'edgtoken',
          name: 'EDG Token',
          href: 'https://edgelessgroup.io/token',
        },
        {
          id: 'blog',
          name: 'Blog',
          href: 'https://blog.edgelessgroup.io/',
        },
      ],
    },
    {
      name: 'Platform',
      items: [
        {
          id: 'affiliate',
          name: 'Affiliate',
          href: 'https://affiliate.edgeless.io',
        },
        {
          id: 'fairness',
          name: 'Fairness',
          routerLink: ['/', { outlets: { modal: 'fairness' } }],
        },
        {
          id: 'staking',
          name: 'Staking',
          href: 'https://staking.edgelessgroup.io/',
        },
      ],
    },
  ];

  constructor() {
    //
  }

  ngOnInit() {}

  ngOnDestroy() {}

  ngAfterViewInit() {
    this.showSeal();
  }

  private showSeal(): void {
    if (environment.production) {
      try {
        (<any>window).apg_d653c118_9b0f_428b_b12d_624aa6833c25.init();
      } catch (e) {
        logger.error(e);
      }
      this.prepareSeal();
    }
  }

  // Renews seal every 15 minutes.
  private prepareSeal(): void {
    setTimeout(() => {
      this.showSeal();
    }, 60 * 15 * 1000);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/footer/footer.component.ts